import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  isMobile: false,
};

const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    handleSidebar(state, action) {
      state.isMobile = action.payload;
    },
  },
});

export const { handleSidebar } = layoutSlice.actions;

export default layoutSlice.reducer;
